<div class="fullcontainer">
  <br />
  <br />

  <div class='titleContainer'>
    <h2 class='header' style='color: #006498'>Current Stock Levels</h2>

    <div>
      <button class='btn btn-secondary' routerLink='/warehousing/dashboard'><i class="fas fa-tachometer-alt"></i> Dashboard</button>&nbsp;
      <button class='btn btn-secondary' routerLink='/warehousing/goods-in'><i class="fas fa-dolly"></i> Goods In</button>&nbsp;
      <button class='btn btn-secondary' routerLink='/warehousing/goods-out'><i class="fas fa-dolly-flatbed"></i> Goods Out</button>&nbsp;
      <button class='btn btn-secondary' routerLink='/warehousing/transfer'><i class="fas fa-exchange-alt"></i> Transfer</button>&nbsp;
      <button class='btn btn-secondary' routerLink='/warehousing/adjustment'><i class="fas fa-sliders-h"></i> Adjustment</button>&nbsp;
      <button class='btn btn-secondary' routerLink='/warehousing/stock-movements'><i class="fas fa-history"></i> Movement History</button>&nbsp;
      <button class='btn btn-secondary' routerLink='/warehousing/reports'><i class="fas fa-chart-line"></i> Reports</button>&nbsp;
    </div>
  </div>
  <br />

  <div class="form-row">
    <div class="form-group col-md-4">
      <label>Warehouse</label>
      <select class='form-control' (change)='this.onWarehouseChanged($event.target.value)'>
        <option value='-1'>All warehouses</option>
        @for (item of this.warehouses; track item) {
          <option [value]='item.id' [selected]='this.selectedWarehouseId === item.id'>{{ item.name }}</option>
        }
      </select>
    </div>
    <div class="form-group col-md-4">
      <label>Location</label>
      <select class='form-control' [disabled]='this.selectedWarehouseId === -1' (change)='this.onLocationChanged($event.target.value)'>
        <option value='-1'>All locations</option>
        @for (item of this.locations; track item) {
          <option [value]='item.id' [selected]='this.selectedLocationId === item.id'>{{ item.aisle }} / {{ item.shelf }}</option>
        }
      </select>
    </div>
    <div class="form-group col-md-4">
      <label>Product</label>
      <select class='form-control' (change)='this.onProductChanged($event.target.value)'>
        <option value='-1'>All products</option>
        @for (item of this.products; track item) {
          <option [value]='item.id' [selected]='this.selectedProductId === item.id'>{{ item.name }}</option>
        }
      </select>
    </div>
  </div>
  <br />

  <app-grid
    entity='product-stock-level'
    [filters]='this.filters'
    [columns]='this.columns'
    [relationships]='this.relationships'
    [searchFilters]='this.searchFilters'
    [searchFields]='this.searchFields'
    sortColumn='id'
    sortDirection='desc'
  ></app-grid>
</div>
